import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Home } from './pages/Home';
import { WeightLoss } from './pages/WeightLoss';
import { MensHealth } from './pages/MensHealth';
import { Investors } from './pages/Investors';
import { PhysicianProfile } from './pages/PhysicianProfile';
import { PhysicianProfileHodor } from './pages/PhysicianProfileHodor';
import { ScrollToTop } from './components/ScrollToTop';
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
      <ScrollToTop data-id="element-6" />
      <Routes data-id="element-7">
        <Route path="/" element={<App data-id="element-9" />} data-id="element-8">
          <Route index element={<Home data-id="element-11" />} data-id="element-10" />
          <Route path="weight-loss" element={<WeightLoss data-id="element-13" />} data-id="element-12" />
          <Route path="mens-health" element={<MensHealth data-id="element-15" />} data-id="element-14" />
          <Route path="investors" element={<Investors data-id="element-17" />} data-id="element-16" />
          <Route path="network-physician/Manharkumar-Patel" element={<PhysicianProfile data-id="element-19" />} data-id="element-18" />
          <Route path="network-physician/Hodor-Jonathan" element={<PhysicianProfileHodor data-id="element-21" />} data-id="element-20" />
        </Route>
      </Routes>
    </BrowserRouter>;
}